/* eslint-disable import/prefer-default-export */
import { Beneficiary } from 'types';
import beneficiaryStatus from 'constants/beneficiaryStatus';
import {
  isBeneficiaryCanceled,
  isBeneficiaryPaused,
} from '../../BeneficiaryList/utils/beneficiaryStatus';

export const getBeneficiaryStatus = (beneficiary: Beneficiary): string => {
  if (isBeneficiaryPaused(beneficiary)) {
    return beneficiaryStatus.var.PAUSED;
  }

  if (isBeneficiaryCanceled(beneficiary)) {
    return beneficiaryStatus.var.CANCELED;
  }

  if ((beneficiary?.percentConsolidated || 0) < 100) {
    return beneficiaryStatus.var.ACTIVE;
  }

  return beneficiaryStatus.var.CONSOLIDATED;
};
